module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// C:/angular/aws-lex-web-ui-master/aws-lex-web-ui-master/node_modules/browserify-sign/algos.js
// module id = ../../../node_modules/browserify-sign/algos.js
// module chunks = 0